import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {CSSTransition} from 'react-transition-group'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {BlockProps} from '../../../../lib/Block'
import {
  filterOutRedundantPostFinancePaymentMethods,
  filterOutSpecificCreditCardPaymentMethods,
} from '../../../../lib/helpers'
import {PaymentPaymentMethodDetails} from '../elements/PaymentPaymentMethodDetails'
import {PaymentPaymentMethods} from '../elements/PaymentPaymentMethods'

///////////////////////////////////////////////////////////////////////////////

export const PaymentPaymentMethodsBlock: FC<BlockProps> = observer((props) => {
  const {api} = useStores<{api: WidgetApi}>()
  const {position} = props
  const blockId = api.ui.generateUniqueElementId('payment-methods-')
  const form = api.paymentForm
  const paymentMethodSelected = !!form.getPaymentMethod()
  const {uiTransitionTimeout: timeout} = api.computedConfig

  let paymentMethods = form.getPossiblePaymentMethods()
  paymentMethods = filterOutRedundantPostFinancePaymentMethods(paymentMethods)
  paymentMethods = filterOutSpecificCreditCardPaymentMethods(paymentMethods)

  let blockTitle = api.trans('blocks.payment_payment_methods.title')
  let blockLegend = api.trans('blocks.payment_payment_methods.legend')

  if (paymentMethods.length === 1) {
    blockTitle = api.trans('blocks.payment_payment_methods.title_single', {
      defaultValue: blockTitle,
    })
    blockLegend = api.trans('blocks.payment_payment_methods.legend_single', {
      defaultValue: blockLegend,
    })
  }

  return (
    <section
      id={blockId}
      className="widget-block payment-payment-methods-block"
    >
      <div className="widget-block-header">
        <h2 className="title">
          <span className="position">{position}</span>
          <span className="text">{blockTitle}</span>
        </h2>
      </div>

      <div className="widget-block-content">
        <fieldset>
          <legend>{blockLegend}</legend>

          <CSSTransition
            in={!paymentMethodSelected}
            mountOnEnter
            unmountOnExit
            timeout={timeout}
            classNames="swap-down"
          >
            <PaymentPaymentMethods
              topElementId={blockId}
              paymentMethods={paymentMethods}
            />
          </CSSTransition>

          <CSSTransition
            in={paymentMethodSelected}
            mountOnEnter
            unmountOnExit
            timeout={timeout}
            classNames="swap-up"
          >
            <PaymentPaymentMethodDetails
              topElementId={blockId}
              paymentMethods={paymentMethods}
            />
          </CSSTransition>
        </fieldset>
      </div>
    </section>
  )
})
